import {
  useGlobalNotifier,
  useMessage,
  useSpreadsheetState,
} from "@vrf/fr-vrf-core-react";
import { FrVrfSpreadsheet } from "@vrf/fr-vrf-spreadsheet-react";
import {
  FrVrfAccordion,
  FrVrfButton,
  FrVrfCheckboxesField,
  FrVrfFooter,
  FrVrfFormPanel,
  FrVrfSingleLineInputField,
} from "@vrf/fr-vrf-web-components-react";
import { stringify } from "../../util/querystring-util";
import React, { useEffect, useMemo } from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { createPath, useLocation, useNavigate } from "react-router-dom";
import {
  ComponentProjectListPageInitialState,
  CpntPjtKeys,
  CpntPjtList,
  usePageState,
} from ".";
import { useAppState } from "../../app";
import { ApplicationMessageScreen } from "../../messages/screen-message";
import {
  UpdateCpntPjtList,
  useGetComponentProjectList,
  useUpdateComponentProjects,
} from "../../services/component-projects";
import { useGetGeneralCodes } from "../../services/data-list";
import {
  EnvTypeCd,
  InDefCommonFlagType,
  TcktStsTypeCpntPrjPrgrs,
} from "../../util/general-code/enums/general-codes";
import { Option } from "../../util/option";
import {
  clearBackenddMessages,
  mappingErrorResponseToSpreadsheet,
} from "../../util/spreadsheet-data-utils";
import {
  AddCmpProjectDialogContent,
  useAddCmpProjectDialogState,
} from "../dialog/add-cmp-project-dialog";
import { SpreadsheetState } from "../dialog/deployment-request-infomation-input-dialog";
import {
  COMPONENT_PROJECT_LIST_TEMPLATE_FILE_URL,
  PJT_STS_LIST_PARAM_DELIMITER,
  REQUEST_CD_TYPES,
  requestCdTypes,
} from "./ComponentProjectListConstant";
import { Cell } from "@vrf/fr-vrf-spreadsheet-core-templating";
import _, { set } from "lodash";

export const ComponentProjectListPageContent = () => {
  const { showConfirmationDialog, showToast, errorMessages, resetUserError } =
    useGlobalNotifier();
  const { messageForScreen } = useMessage();
  const search = useLocation().search;
  const queryParameter = new URLSearchParams(search);
  const params = {
    dipByRgn: queryParameter.get("dipByRgn") ?? "",
    rootCpntId: queryParameter.get("rootCpntId") ?? "",
    cpntId: queryParameter.get("cpntId") ?? "",
    cpntPjtSts: queryParameter.get("cpntPjtSts") ?? "",
    pjtId: queryParameter.get("pjtId") ?? "",
  };
  const [_appState, setAppState] = useAppState();
  const [pageState, setPageState] = usePageState();
  const [addCmpProjectDialogState, setAddCmpProjectDialogState] =
    useAddCmpProjectDialogState();
  const [getGeneralCodesResponse, sendGeneralCodesRequest] =
    useGetGeneralCodes();
  const [getComponentProjectListResponse, sendGetComponentProjectListRequest] =
    useGetComponentProjectList();
  const [updateComponentProjectsResponse, sendUpdateComponentProjectsRequest] =
    useUpdateComponentProjects();

  const [spreadsheetState, setSpreadsheetState, initSpreadsheetState] =
    useSpreadsheetState<SpreadsheetState>();
  const navigate = useNavigate();

  const EVENT_CLICK_PJT_NAME = "pjtName";
  const EVENT_CLICK_CPNT_ID = "cpntId";
  const EVENT_CLICK_PJT_NAME_NEW_TAB_ICON = "pjtName_newTabIcon";
  const EVENT_CLICK_CPNT_ID_NEW_TAB_ICON = "cpntId_newTabIcon";
  const EVENT_EDIT_PJT_STS = "pjtSts";
  const EVENT_EDIT_STG_ONLY_FLG = "stgOnlyFlg";
  const EVENT_EDIT_OTHER_STG_FLG = "othrStgStupFlg";
  const EVENT_EDIT_STG_IFD_PSB_FLG = "stgIfdDplymntPsblFlg";
  const EVENT_EDIT_PRD_IFD_PSB_FLG = "prdIfdDplymntPsblFlg";
  const EVENT_EDIT_STG_SCHED_DATE = "stgSchedDplymntDate";
  const EVENT_EDIT_PRD_SCHED_DATE = "prdSchedDplymntDate";

  const spreadsheetInitialData = useMemo<SpreadsheetState>(() => {
    const cpntPjtList = pageState.cpntPjtList;
    const generalCode = pageState.generalCode;
    return {
      cpntPjtList: cpntPjtList,
      generalCode: generalCode,
    };
  }, [pageState.cpntPjtList, pageState.generalCode]);

  const [isInitialized, setIsInitialized] = useState(false);
  const onInitialDisplayed = () => {
    resetUserError();
    setIsInitialized(true);
    sendGeneralCodesRequest({ cdTypes: requestCdTypes });
    const newPjtStsList = !!params.cpntPjtSts
      ? params.cpntPjtSts.split(PJT_STS_LIST_PARAM_DELIMITER)
      : [];
    sendGetComponentProjectListRequest({
      dipByRgn: params.dipByRgn,
      rootCpntId: params.rootCpntId,
      cpntId: params.cpntId,
      ifpjtId: params.pjtId,
      cpntPjtSts: newPjtStsList,
    });
    setAppState((prevState) => ({
      ...prevState,
      title: "Component Project List",
    }));
    setPageState((prevState) => ({
      ...prevState,
      dipByRegion: params.dipByRgn,
      rootComponentId: params.rootCpntId,
      componentId: params.cpntId,
      pjtStsList: newPjtStsList,
    }));
  };

  const onGetGeneralCodesResponse = () => {
    let inDefCommonFlagType = [] as Option[];
    let tcktStsTypeCpntPrjPrgrs = [] as Option[];
    const GeneralCode = getGeneralCodesResponse?.gnrlCdTypeList ?? [];
    if (GeneralCode.length === 0) {
      return;
    }

    GeneralCode.map((e) => {
      switch (e.cdType) {
        case REQUEST_CD_TYPES.IN_DEF_COMMON_FLAG_TYPE:
          inDefCommonFlagType = e.cdList;
          break;
        case REQUEST_CD_TYPES.TCKT_STS_TYPE_CPNT_PRJ_PRGRS:
          tcktStsTypeCpntPrjPrgrs = e.cdList;
          break;
      }
    });
    setPageState((prevState) => ({
      ...prevState,
      generalCode: {
        inDefCommonFlagType: inDefCommonFlagType,
        tcktStsTypeCpntPrjPrgrs: tcktStsTypeCpntPrjPrgrs,
      },
    }));
  };

  const onGetComponentProjectListResponse = () => {
    if (!getComponentProjectListResponse) {
      return;
    }
    const componentProjectList =
      getComponentProjectListResponse?.cpntPjtList ?? [];
    const cpntPjtList = [] as CpntPjtList[];
    componentProjectList.forEach((e, idx) => {
      const cpntPjt = {} as CpntPjtList;
      cpntPjt.idx = idx;
      cpntPjt.isEdited = false;
      cpntPjt.isChecked = false;
      cpntPjt.cpntPjt = e;
      cpntPjt.errorColumnList = [];
      cpntPjt.errorMessage = "";
      cpntPjt.messageList = [];
      cpntPjtList.push(cpntPjt);
    });
    setPageState((prevState) => ({
      ...prevState,
      cpntPjtList: cpntPjtList,
    }));
  };

  const onUpdateComponentProjectsResponse = () => {
    if (!updateComponentProjectsResponse) {
      return;
    }
    if (Array.isArray(updateComponentProjectsResponse)) {
      const currentrecords: CpntPjtList[] = spreadsheetState
        ? [...spreadsheetState.cpntPjtList]
        : [];

      const currentrecordsWithoutBackendError = currentrecords.map((row) =>
        clearBackenddMessages(row),
      );
      const newSpreadsheetRecordData: CpntPjtList[] =
        mappingErrorResponseToSpreadsheet(
          updateComponentProjectsResponse,
          currentrecordsWithoutBackendError,
          ComponentProjectListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        cpntPjtList: newSpreadsheetRecordData,
      });
    } else {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
      sendGetComponentProjectListRequest({
        dipByRgn: pageState.dipByRegion,
        rootCpntId: pageState.rootComponentId,
        cpntId: pageState.componentId,
        cpntPjtSts: pageState.pjtStsList,
        ifpjtName: pageState.projectName,
        ifpjtId: params.pjtId,
      });
    }
  };

  const onCloseAddCmpProjectDialog = () => {
    if (addCmpProjectDialogState.isShow || !isInitialized) return;
    const newPjtStsList = !!params.cpntPjtSts
      ? params.cpntPjtSts.split(PJT_STS_LIST_PARAM_DELIMITER)
      : [];
    sendGetComponentProjectListRequest({
      dipByRgn: params.dipByRgn,
      rootCpntId: params.rootCpntId,
      cpntId: params.cpntId,
      ifpjtId: params.pjtId,
      cpntPjtSts: newPjtStsList,
    });
  };

  useEffect(onInitialDisplayed, []);
  useEffect(onGetGeneralCodesResponse, [getGeneralCodesResponse]);
  useEffect(onGetComponentProjectListResponse, [
    getComponentProjectListResponse,
  ]);
  useEffect(onUpdateComponentProjectsResponse, [
    updateComponentProjectsResponse,
  ]);
  useEffect(onCloseAddCmpProjectDialog, [addCmpProjectDialogState.isShow]);

  const transition = (
    path: string,
    params: Record<string, string>,
    isOpenNewTab?: boolean,
  ) => {
    const href = createPath({
      pathname: `${path}`,
      search: stringify(params),
    });
    if (isOpenNewTab) {
      window.open(window.location.pathname + "#" + href);
    } else {
      navigate(href);
    }
  };

  const transitionHandle = (page: string) => (event: CustomEvent) => {
    if (!pageState.isEdited) {
      const href = createPath({
        pathname: `${page}`,
      });
      navigate(href);
      return; // No confirmation dialog needed
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
      onOkButtonClicked: () => {
        const href = createPath({
          pathname: `${page}`,
        });
        navigate(href);
        return;
      },
    });
  };

  const onChangeValueHandle = (name: string) => (event: CustomEvent) => {
    const inputValue = event.detail.value;
    setPageState((prevState) => ({
      ...prevState,
      [name]: inputValue,
    }));
  };

  const onClickAddCmpPrj = () => {
    if (!pageState.isEdited) {
      setAddCmpProjectDialogState((prevState) => ({
        ...prevState,
        isShow: true,
      }));
      return;
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
      onOkButtonClicked: () => {
        setAddCmpProjectDialogState((prevState) => ({
          ...prevState,
          isShow: true,
        }));
      },
    });
  };

  const onCellEdited = (event: CustomEvent) => {
    const eventName: string = event.detail.name;
    const value = event.detail.cell.value;
    const rowIndex: number = event.detail.value.idx;
    const isChanged = event.detail.cell.row.isChanged;
    let spreadsheetData: SpreadsheetState = JSON.parse(
      JSON.stringify(spreadsheetState),
    );
    const cpntPjtList: CpntPjtList[] = spreadsheetData.cpntPjtList;
    if (
      eventName === EVENT_EDIT_PJT_STS ||
      eventName === EVENT_EDIT_STG_ONLY_FLG ||
      eventName === EVENT_EDIT_OTHER_STG_FLG ||
      eventName === EVENT_EDIT_STG_IFD_PSB_FLG ||
      eventName === EVENT_EDIT_PRD_IFD_PSB_FLG ||
      eventName === EVENT_EDIT_STG_SCHED_DATE ||
      eventName === EVENT_EDIT_PRD_SCHED_DATE
    ) {
      cpntPjtList[rowIndex]["cpntPjt"][eventName] = value;
      cpntPjtList[rowIndex].isEdited = isChanged;

      spreadsheetData.cpntPjtList = cpntPjtList;
      setSpreadsheetState(spreadsheetData);
      setPageState((prevState) => ({
        ...prevState,
        isEdited: true,
      }));
    }
  };

  const onCellBulkEdited = (event: CustomEvent) => {
    if (!spreadsheetState) return;
    const newUserRoleList = _.cloneDeep(
      spreadsheetState?.cpntPjtList,
    ) as CpntPjtList[];

    const colName: CpntPjtKeys = event.detail.name as CpntPjtKeys;

    event.detail.affectedCells.cells.forEach((item: Cell) => {
      const value: string = item.value;
      const rowIdx: number = item.data.index;

      newUserRoleList[rowIdx].cpntPjt[colName] = value;
      newUserRoleList[rowIdx].isEdited = true;
    });

    setPageState({
      ...pageState,
      isEdited: true,
    });

    setSpreadsheetState({
      ...spreadsheetState,
      cpntPjtList: newUserRoleList,
    });
  };

  const onCellClicked = (event: CustomEvent) => {
    const eventName: string = event.detail.name;
    const value = event.detail.value;
    if (eventName === EVENT_CLICK_PJT_NAME) {
      const newParams = {
        cpntPjtId: value.cpntPjt.pjtId,
      };
      if (!pageState.isEdited) {
        transition(`/component-project-detail`, newParams);
        return;
      }
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
        onOkButtonClicked: () => {
          transition(`/component-project-detail`, newParams);
        },
      });
    }
    if (eventName === EVENT_CLICK_PJT_NAME_NEW_TAB_ICON) {
      const newParams = {
        cpntPjtId: value.cpntPjt.pjtId,
      };
      transition(`/component-project-detail`, newParams, true);
    }
    if (eventName === EVENT_CLICK_CPNT_ID) {
      const newParams = {
        dipByRgn: value.cpntPjt.dipByRgn,
        rootCpntId: value.cpntPjt.rootCpntId,
        cpntId: value.cpntPjt.cpntId,
        godFlg: InDefCommonFlagType.NO,
      };
      if (!pageState.isEdited) {
        transition(`/component-detail`, newParams);
        return;
      }
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
        onOkButtonClicked: () => {
          transition(`/component-detail`, newParams);
        },
      });
    }
    if (eventName === EVENT_CLICK_CPNT_ID_NEW_TAB_ICON) {
      const newParams = {
        dipByRgn: value.cpntPjt.dipByRgn,
        rootCpntId: value.cpntPjt.rootCpntId,
        cpntId: value.cpntPjt.cpntId,
        godFlg: InDefCommonFlagType.NO,
      };
      transition(`/component-detail`, newParams, true);
    }
  };

  const onClickSearch = () => {
    const search = () => {
      sendGetComponentProjectListRequest({
        dipByRgn: pageState.dipByRegion,
        rootCpntId: pageState.rootComponentId,
        cpntId: pageState.componentId,
        cpntPjtSts: pageState.pjtStsList,
        ifpjtName: pageState.projectName,
        ifpjtId: params.pjtId,
      });
      setPageState((prevState) => ({
        ...prevState,
        isEdited: false,
      }));
    };
    if (!pageState.isEdited) {
      resetUserError();
      search();
      return;
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
      onOkButtonClicked: () => {
        resetUserError();
        search();
      },
    });
  };

  const onClickSave = () => {
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
      onOkButtonClicked: () => {
        resetUserError();
        if (!spreadsheetState) return;
        const cpntPjtList: CpntPjtList[] = JSON.parse(
          JSON.stringify(spreadsheetState.cpntPjtList),
        );
        const updateCpntPjtList = [] as UpdateCpntPjtList[];
        cpntPjtList.forEach((e, idx) => {
          if (e.isEdited) {
            updateCpntPjtList.push({
              index: idx,
              pjtId: e.cpntPjt.pjtId ?? "",
              pjtSts: e.cpntPjt.pjtSts ?? "",
              stgOnlyFlg: e.cpntPjt.stgOnlyFlg ?? "",
              othrStgStupFlg: e.cpntPjt.othrStgStupFlg ?? "",
              stgDplymntPlnDate: e.cpntPjt.stgSchedDplymntDate ?? "",
              prdDplymntPlnDate: e.cpntPjt.prdSchedDplymntDate ?? "",
              stgIfdDplymntPsblFlg: e.cpntPjt.stgIfdDplymntPsblFlg ?? "",
              prdIfdDplymntPsblFlg: e.cpntPjt.prdIfdDplymntPsblFlg ?? "",
              updateDateTime: e.cpntPjt.updateDateTime ?? "",
            });
          }
        });
        sendUpdateComponentProjectsRequest({
          cpntPjtList: updateCpntPjtList,
        });
      },
    });
  };

  return (
    <>
      {addCmpProjectDialogState.isShow && (
        <AddCmpProjectDialogContent></AddCmpProjectDialogContent>
      )}
      {/* Search Content */}
      <FrVrfAccordion>
        <FrVrfFormPanel columns={3}>
          <FrVrfSingleLineInputField
            labelContent="DIP By Region"
            content={pageState.dipByRegion}
            onInputValueChanged={onChangeValueHandle("dipByRegion")}
            errorMessage={errorMessages(pageState.fieldPath.dipByRgn)}
          />
          <FrVrfSingleLineInputField
            labelContent="Root Component ID"
            content={pageState.rootComponentId}
            onInputValueChanged={onChangeValueHandle("rootComponentId")}
            errorMessage={errorMessages(pageState.fieldPath.rootCpntId)}
          />
          <FrVrfSingleLineInputField
            labelContent="Component ID"
            content={pageState.componentId}
            onInputValueChanged={onChangeValueHandle("componentId")}
            errorMessage={errorMessages(pageState.fieldPath.cpntId)}
          />
          <FrVrfCheckboxesField
            labelContent="Project Status"
            options={[
              {
                label: "In Progress",
                value: TcktStsTypeCpntPrjPrgrs.COMPONENT_PROJECT_IN_PROGRESS,
              },
              {
                label: "Waiting for Execution",
                value:
                  TcktStsTypeCpntPrjPrgrs.COMPONENT_PROJECT_REQUIREMENT_DESIGN,
              },
              {
                label: "Complete",
                value: TcktStsTypeCpntPrjPrgrs.COMPONENT_PROJECT_COMPLETE,
              },
            ]}
            checkList={pageState.pjtStsList}
            onCheckboxesChanged={onChangeValueHandle("pjtStsList")}
            errorMessage={errorMessages(pageState.fieldPath.pjtSts)}
          />
          <FrVrfSingleLineInputField
            labelContent="Project Name"
            content={pageState.projectName}
            onInputValueChanged={onChangeValueHandle("projectName")}
          />
          <div style={{ textAlign: "center" }}>
            <FrVrfButton
              content="Search"
              theme="primary"
              size="large"
              onClicked={onClickSearch}
            />
          </div>
        </FrVrfFormPanel>
      </FrVrfAccordion>
      <FrVrfSpreadsheet
        data={spreadsheetInitialData}
        templateUrl={COMPONENT_PROJECT_LIST_TEMPLATE_FILE_URL}
        onInitialized={initSpreadsheetState}
        onCellEdited={onCellEdited}
        onCellClicked={onCellClicked}
        onCellBulkEdited={onCellBulkEdited}
        maxHeight={800}
      />
      <FrVrfFooter>
        <FrVrfButton
          content="Add Cmp Project"
          theme="primary"
          size="large"
          onClicked={onClickAddCmpPrj}
          authActId="component_project_list.button.add_cmp_project"
        />
        <FrVrfButton
          content="Request STG Deployment"
          theme="secondary"
          size="large"
          onClicked={transitionHandle(
            `/component-project-list-request?envType=${EnvTypeCd.STG}`,
          )}
          authActId="component_project_list.button.request_stg_deployment"
        />
        <FrVrfButton
          content="Request PRD Deployment"
          theme="secondary"
          size="large"
          onClicked={transitionHandle(
            `/component-project-list-request?envType=${EnvTypeCd.PRD}`,
          )}
          authActId="component_project_list.button.request_prd_deployment"
        />
        <FrVrfButton
          content="Save"
          theme="primary"
          size="large"
          disabled={!pageState.isEdited}
          onClicked={onClickSave}
          authActId="component_project_list.button.save"
        />
      </FrVrfFooter>
    </>
  );
};
